import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';

const Main = styled.div`
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
  padding: var(--space-11);
  display: flex;
  flex-direction: column;
  gap: var(--space-10);
  ${mobile_xl(css`
    gap: var(--space-8);
  `)}
`;
const Title = styled.div`
  ${Typography.body_md_medium}
  color: var(--text-primary);
`;
const Price = styled.div`
  ${Typography.heading_md}
  color: var(--text-primary);
`;
export { Main, Title, Price };
